import styled from '@emotion/styled'
import { Button as MuiButton, CircularProgress } from '@mui/material'

const Button = ({
  text,
  variant = 'contained',
  onClick = () => {},
  padding,
  color,
  font_weight,
  text_transform,
  background_color,
  loading,
  font_size,
  type = 'button',
  alignment = 'center',
  width,
  disabled,
  readOnly,
  border_radius,
  ...props
}) => {
  return (
    <SubmitButtonContainer alignment={alignment}>
      <SubmitButton
        padding={padding}
        variant={variant}
        onClick={onClick}
        color={color}
        font_weight={font_weight}
        background_color={background_color}
        text_transform={text_transform}
        disabled={disabled || loading}
        readOnly={readOnly}
        type={type}
        font_size={font_size}
        width={width}
        border_radius={border_radius}
        {...props}
      >
        {loading ? (
          <SubmitButtonLoadingContainer>
            {text}
            <CircularProgress size={18} color="white" />
          </SubmitButtonLoadingContainer>
        ) : (
          text
        )}
      </SubmitButton>
    </SubmitButtonContainer>
  )
}

const SubmitButtonContainer = styled.div`
  padding: 0;
  text-align: ${({ alignment }) => alignment};
`

const SubmitButton = styled(MuiButton)`
  background-color: ${({ theme, background_color }) =>
    background_color || theme.colors.yellow};
  color: ${({ color }) => color || 'white'};
  font-weight: ${({ font_weight }) => font_weight || 500};
  font-size: ${({ font_size }) => font_size || '1rem'};
  padding: ${({ padding }) => padding || '0.5rem'};
  box-shadow: none;
  text-transform: ${({ text_transform }) => text_transform || 'uppercase'};
  height: ${({ height }) => height || '100%'};
  width: ${({ width }) => width || '100%'};
  ${({ border_radius }) =>
    border_radius !== undefined ? `border-radius: ${border_radius};` : ''}

  &:hover {
    box-shadow: none;
  }
`

const SubmitButtonLoadingContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export default Button
